export default __webpack_public_path__ + "static/media/closeIcon.19bffb99.png";